// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import ActaAuthProvider from 'pa_kit/auth';
import LocalSettingsProvider from 'services/local_settings';
import AppRoutes from './approutes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>        
        <HelmetProvider>
            <LocalSettingsProvider>
                <ActaAuthProvider>
                    <AppRoutes />
                </ActaAuthProvider>
            </LocalSettingsProvider>
        </HelmetProvider>        
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
